import { EntityType } from '../../../shared/enums/entity-type.enum';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { OrderStatus } from '../../orders/enums/order-status.enum';
import { QueueStatus } from '../../queue/enums/queue-status.enum';

export class Password {
  name: string;
  password: string;
  status: QueueStatus | OrderStatus;

  constructor(obj: any = {}, type: EntityType) {
    Object.assign(this, obj);

    if (this.password && this.password.length > 0) {
      this.password = this.password.toString().slice(-3);
    }
    if (this.status != null && this.status['code'] == null) {
      if (type == EntityType.QUEUE) {
        this.status = UtilHelper.getEnumByCod(this.status, QueueStatus);
      } else {
        this.status = UtilHelper.getEnumByCod(this.status, OrderStatus);
      }
      if (this.status == null) {
        this.status = QueueStatus.UNDEFINED;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/passwords/models/password.model.ts